export const qnPrimary = {
  disabled: "#3f51b51a",
  50: '#F8F9FE',// primary-5
  100: '#F2F6FF', // primary-4
  200: '#E4E8FD', // primary-3
  300: '#C9D1FC', // primary-2
  400: '#798DF7', // primary-1

  main: 'rgb(63,81,181,1)', // primary
  mainBackup:'rgb(63,81,181,1)', // primary
  mainChannel: "63 81 181",
  mainChannelBackup: "63 81 181",
  textButtonColor: 'rgb(255,255,255)',
  textButtonColorBackup: 'rgb(255,255,255)',

  background: "rgb(249, 249, 250, 1)",
  backgroundBackup: "rgb(249, 249, 250, 1)",

  textColor: "rgb(72,74,91,1)",
  textColorBackup: "rgb(72,74,91,1)",
  textColorChannel: "72 74 91",
  textColorChannelBackup: "72 74 91",

  600: '#5c75cf', // primary+1
  700: '#303F9F', // primary+2
  800: '#1A237E', // primary+3,
};

export const qnGreen = {
  100: '#F0F9F2', // green-4
  200: '#E0F2E4', // green-3
  300: '#C1E4C9', // green-2
  400: '#83CA94', // green-1
  500: '#52B267', // green
  600: '#1BA965', // green+1
  700: '#419250', // green+2
  800: '#29612F', // green+3
};

export const qnRed = {
  100: '#FDECEB', // red-4
  200: '#FAD7D5', // red-3
  300: '#F6AFAC', // red-2
  400: '#ED5F59', // red-1
  500: '#E25241', // red
  700: '#C33F38', // red+2
  900: '#A92E26', // red+3
};

export const qnRose = {
  200: '#fff2f2', // rose-3
  300: '#ffdfdf', // rose-2
  400: '#ffcaca', // rose-1
  500: '#de808e', // rose
  600: '#c0727d', // rose+1
  700: '#9e2e42', // rose+2
};

export const qnOrange = {
  100: '#FDEDE6', // orange-4
  200: '#FADACB', // orange-3
  300: '#F6B697', // orange-2
  400: '#ED752F', // orange-1
  500: '#F19C38', // orange
  700: '#E58231', // orange+2
  800: '#CF470D', // orange+3
};

export const qnPink = {
  100: '#FDF2F5', // pink-4
  200: '#FCE6EB', // pink-3
  300: '#F098AC', // pink-2
  400: '#E2325A', // pink-1
  500: '#D73964', // pink
  700: '#B32E5B', // pink+2
  800: '#7C1E4E', // pink+3
};

export const qnViolet = {
  100: '#F8E7FD', // violet-4
  200: '#F0CDFB', // violet-3
  300: '#d6cfff', // violet-2
  400: '#bfaffd', // violet-1
  500: '#8e79e0', // violet
  600: '#745adb', // violet+1
  700: '#492fb0', // violet+2
};

export const qnTurquoise = {
  100: '#e5f2ff', // turquoise-4
  200: '#dcf9ff', // turquoise-3
  300: '#a8dfec', // turquoise-2
  500: '#59b7d4', // turquoise
  600: '#3387a0', // turquoise+1
  700: '#215b6d', // turquoise+2
};

export const qnBlueGrey = {
  900: '#FAFAFD',// blueGrey-6
  50: '#F6F7FB',// blueGrey-5
  100: '#EDEFF7', // blueGrey-4
  200: '#D9DDEF', // blueGrey-3
  300: '#B3BCDE', // blueGrey-2
  400: '#6878BD', // blueGrey-1
  500: '#575E92', // blueGrey
  700: '#474C7D', // blueGrey+2
  800: '#323258', // blueGrey+3,
};

export const qnTeal = {
  50: '#F4FCF9',// teal-5
  100: '#E8F9F4', // teal-4
  200: '#CFF2E7', // teal-3
  300: '#A0E4D0', // teal-2
  400: '#41CAA1', // teal-1
  500: '#419488', // teal
  700: '#33776B', // teal+2
  800: '#1D4C40', // teal+3,
};

export const qnBlue = {
  100: '#E6EEFE', // blue-4
  200: '#CEDEFD', // blue-3
  300: '#9DBDFA', // blue-2
  400: '#3B7BF6', // blue-1
  500: '#3476CB', // blue
  700: '#2C65BA', // blue+2
  800: '#1B499B', // blue+3,
};

export const qnNeutrals = {
  bg: '#f9f9fa',
  lightGrey: '#dcdfe9',
  lightGreyBG: '#F2F2F8',
  strokeForWhiteElements: '#e9ecf5',
  neutralButtonsBg: '#f2f4f9',
  bordersOnBg: '#e8e8e8',
  alert: '#fe6c6c',
  buttonsOnBlue: '#7F9BE4'
};

export const qnTexts = {
  placeholder: '#cacdd2',
  darkGreyMediumEmphasis: '#484a5b',
  placeholderDarker: '#676870',
  darkIcons: '#55576a',
  action: '#70728F',
  actionBorder: '#9194A7'
};
